import {
  IonButton,
  IonButtons,
  IonChip,
  IonContent,
  IonHeader,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonModal,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { closeOutline } from "ionicons/icons";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { selectOrganizations } from "../../../store/organizations/selectors/selectOrganizations";
import { selectUserProfileLocationFilters } from "../../../store/userProfileLocation/selector/selectUserProfileLocationFilters";
import { setOrganization } from "../../../store/userProfileLocation"

export const LocationsSelectorOrganizationFilter = () => {
  const dispatch = useDispatch();
  const createFilters = useSelector(selectUserProfileLocationFilters);
  const organizationList = useSelector(selectOrganizations);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [listSearchtext, setListSearchtext] = useState("");

  return (
    <section>
      <IonChip
        onClick={() => setShowFilterModal(true)}
        outline
        color={createFilters.organization ? "primary" : "medium"}
      >
        <IonLabel class="ion-text-nowrap">
          {createFilters.organization?.id ? (
            <IonText color="primary" style={{ fontWeight: 600 }}>
              <span>Cliente: </span>
              {createFilters.organization?.name}
            </IonText>
          ) : (
            <span>Cliente: Todos</span>
          )}
        </IonLabel>
      </IonChip>
      {/* Ventana de selección de cliente (Organization) */}
      <IonModal isOpen={showFilterModal} onDidDismiss={() => setShowFilterModal(false)}>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Filtrar por cliente</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setShowFilterModal(false)}>
                <IonIcon icon={closeOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonSearchbar
            value={listSearchtext}
            onIonChange={({ detail: { value = "" } }) => {
              setListSearchtext(value);
            }}
            debounce={900}
            placeholder="Buscar"
          />
          <IonList>
            <IonListHeader>Clientes</IonListHeader>
            {organizationList
              .filter(({ name }) => name?.toLowerCase().includes(listSearchtext.toLowerCase()))
              .map((organization, index: number) => (
                <IonItem
                  key={index}
                  onClick={() => {
                    dispatch(setOrganization(organization));
                    setShowFilterModal(false);
                  }}
                  button
                  detail
                >
                  <IonLabel>{organization.name}</IonLabel>
                </IonItem>
              ))}
          </IonList>
        </IonContent>
      </IonModal>
    </section>
  );
}